import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayoutMethodsService } from '@app/modules/direct/services/payout-methods.service';
import { Address } from '@app/shared/interfaces/lib/address.interface';

interface TaxInformation {
  type: string;
  // add other properties as needed
}

@Component({
  standalone: false,
  templateUrl: './direct-payouts-methods-add-tax-information.html',
  styleUrls: ['./direct-payouts-methods-add-tax-information.scss'],
})
export class DirectPayoutsMethodsAddTaxInformationComponent implements OnInit {
  payoutId: string;
  step: number = 1;

  type: string = null;

  individualFirstName: string = null;
  individualLastName: string = null;
  individualEmail: string = null;
  individualAddress: string = null;
  individualZip: string = null;
  individualCity: string = null;
  individualState: string = null;
  individualCountry: string = null;
  individualSsn: string = null;

  organizationLegalName: string = null;
  organizationDisregardedEntityName: string = null;
  organizationAddress: string = null;
  organizationZip: string = null;
  organizationCity: string = null;
  organizationState: string = null;
  organizationCountry: string = null;
  organizationEin: string = null;

  wNineName: string = null;
  wNineSignedAt: string = new Date().toISOString().split('T')[0];

  constructor(private route: ActivatedRoute, private payoutMethodsService: PayoutMethodsService, private router: Router) {}

  ngOnInit(): void {
    this.payoutId = this.route.snapshot.params.payoutId;

    this.getTaxInformation();
  }

  getTaxInformation() {
    this.payoutMethodsService.getTaxInformation(this.payoutId).subscribe((data: any) => {
      this.type = data.type;

      this.individualFirstName = data.individual_first_name;
      this.individualLastName = data.individual_last_name;
      this.individualEmail = data.individual_email;
      this.individualAddress = data.individual_address;
      this.individualZip = data.individual_zip;
      this.individualCity = data.individual_city;
      this.individualState = data.individual_state;
      this.individualCountry = data.individual_country;

      this.organizationLegalName = data.organization_legal_name;
      this.organizationDisregardedEntityName = data.organization_disregarded_entity_name;
      this.organizationAddress = data.organization_address;
      this.organizationZip = data.organization_zip;
      this.organizationCity = data.organization_city;
      this.organizationState = data.organization_state;
      this.organizationCountry = data.organization_country;
    });
  }

  previousStep() {
    this.step = this.step - 1;
  }

  canStepForward() {
    if (this.step === 2) {
      if (!this.type) {
        return false;
      }
    }

    if (this.type === 'individual') {
      if (this.step === 3) {
        if (!this.individualFirstName || !this.individualLastName || !this.individualEmail || !this.individualAddress) {
          return false;
        }
      }

      if (this.step === 4) {
        if (!this.individualSsn || this.individualSsn.length !== 9) {
          return false;
        }
      }
    }

    if (this.type === 'organization') {
      if (this.step === 3) {
        if (!this.organizationLegalName || !this.organizationAddress) {
          return false;
        }
      }

      if (this.step === 4) {
        if (!this.organizationEin || this.organizationEin.length !== 9) {
          return false;
        }
      }
    }

    return true;
  }

  nextStep() {
    if (!this.canStepForward()) {
      return;
    }

    this.step = this.step + 1;
  }

  setIndividualAddress(event: Address) {
    this.individualAddress = event.line1;
    this.individualZip = event.postalCode;
    this.individualCity = event.city;
    this.individualState = event.state;
    this.individualCountry = event.country;
  }

  setOrganizationAddress(event: Address) {
    this.organizationAddress = event.line1;
    this.organizationZip = event.postalCode;
    this.organizationCity = event.city;
    this.organizationState = event.state;
    this.organizationCountry = event.country;
  }

  submit() {
    let payload = {
      type: this.type,
      w9_name: this.wNineName,
      // w9SignedAt should NOT be submitted, as this is set automatically by the server
    };

    if (this.type === 'individual') {
      payload['individual_first_name'] = this.individualFirstName;
      payload['individual_last_name'] = this.individualLastName;
      payload['individual_email'] = this.individualEmail;
      payload['individual_address'] = this.individualAddress;
      payload['individual_zip'] = this.individualZip;
      payload['individual_city'] = this.individualCity;
      payload['individual_state'] = this.individualState;
      payload['individual_country'] = this.individualCountry;
      payload['individual_ssn'] = this.individualSsn;
    }

    if (this.type === 'organization') {
      payload['organization_legal_name'] = this.organizationLegalName;
      payload['organization_disregarded_entity_name'] = this.organizationDisregardedEntityName;
      payload['organization_address'] = this.organizationAddress;
      payload['organization_zip'] = this.organizationZip;
      payload['organization_city'] = this.organizationCity;
      payload['organization_state'] = this.organizationState;
      payload['organization_country'] = this.organizationCountry;
      payload['organization_ein'] = this.organizationEin;
    }

    this.payoutMethodsService.updateTaxInformation(this.payoutId, payload).subscribe(() => {
      this.router.navigate(['/direct/payouts']);
    });
  }
}
